import script from "./balance.vue?vue&type=script&setup=true&lang=js"
export * from "./balance.vue?vue&type=script&setup=true&lang=js"

import "./balance.vue?vue&type=style&index=0&id=242d6e56&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242d6e56"]])

export default __exports__